module.exports = __webpack_public_path__ + "images/f18e37fff92a48b142346b8aacfe147e-animondial-sitelogo.jpg";